import React, { Component } from "react";
import { Grid } from "react-bootstrap";
import CustomerInfoRetail from "./components/CustomerInfoRetail";
import CustomerInfoCor from "./components/CustomerInfoCor";
import FacilityInfo from "./components/FacilityInfo";
import "./step-review.style.scss";
import icon from "assets/icons/tick.svg";
import { get } from "lodash";

export default class StepReview extends Component {
  render() {
    const { type, formValues, onSubmit, onPrev } = this.props;
    const processing = get(this.props, "backTestData.processing", {});
    const proposed_interest_rate =
      Number(processing.proposed_interest_rate || 0) * 100;
    return (
      <div style={{ padding: "0 2rem" }}>
        <Grid fluid>
          {type === "retail" ? (
            <CustomerInfoRetail formValues={formValues} isView />
          ) : (
            <CustomerInfoCor formValues={formValues} isView />
          )}
          <div style={{ height: 16 }}></div>

          <FacilityInfo formValues={formValues} isView type={type} />
        </Grid>
        <div className="pricing-rate">
          <img src={icon} alt="" style={{ marginRight: 8 }} />
          Estimated pricing rate:{" "}
          <span className="pricing-rate_rate">
            {proposed_interest_rate.toFixed(2)}
            {"%"}
          </span>
        </div>

        <div className="btns">
          <button
            type="button"
            className="btn btn-secondary btn-prev"
            onClick={onPrev}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary btn-next"
            onClick={onSubmit}
          >
            Next
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/Pricing/NewPricing/StepReview.js